// @react/hooks/useAffiliatePayout.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { affiliatePayoutStore } from '@core/stores';

/**
 * React hook for Payout operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAffiliatePayout } from '@react/hooks';
 *
 * const PayoutList = observer(() => {
 *   const store = useAffiliatePayout();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useAffiliatePayout() {
  return affiliatePayoutStore;
}
